export const AI_ASSISTANT_TOOL_TYPE = 'AI_ASSISTANT_TOOL';
export const AI_ASSISTANT_TOOL_NAME = 'Assistant';
